import React, { memo } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import DashboardChartCard from "./DashboardChartCard";

const CHART_MARGIN = { top: 8, right: 12, left: 0, bottom: 0 };
const INFLOW_COLOR = "#5b9cf5";
const OUTFLOW_COLOR = "#34d399";

const CompletionTrendChart = ({ points = [] }) => (
  <DashboardChartCard
    title="Completion Trend — Team"
    subtitle="Tasks created (inflow) vs completed (outflow)"
  >
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={points} margin={CHART_MARGIN}>
        <CartesianGrid vertical={false} stroke="#f0f1f3" />
        <XAxis
          dataKey="period"
          tick={{ fill: "#9ca3af", fontSize: 12 }}
          axisLine={false}
          tickLine={false}
          dy={8}
        />
        <YAxis
          domain={[0, 48]}
          ticks={[0, 16, 32, 48]}
          tick={{ fill: "#9ca3af", fontSize: 12 }}
          axisLine={false}
          tickLine={false}
          width={32}
        />
        <Tooltip
          cursor={{ stroke: "#e5e7eb" }}
          contentStyle={{
            borderRadius: 8,
            border: "1px solid #e8eaed",
            fontSize: 12,
          }}
        />
        <Line
          type="monotone"
          dataKey="inflow"
          name="Inflow"
          stroke={INFLOW_COLOR}
          strokeWidth={2}
          dot={{ r: 4, fill: INFLOW_COLOR, stroke: "#fff", strokeWidth: 2 }}
          activeDot={{ r: 5 }}
          isAnimationActive={false}
        />
        <Line
          type="monotone"
          dataKey="outflow"
          name="Outflow"
          stroke={OUTFLOW_COLOR}
          strokeWidth={2}
          dot={{ r: 4, fill: OUTFLOW_COLOR, stroke: "#fff", strokeWidth: 2 }}
          activeDot={{ r: 5 }}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  </DashboardChartCard>
);

export default memo(CompletionTrendChart);
